<template>
  <div id="app" class="layout">
    <router-view/>
    <footer-component/>
  </div>
</template>

<script>
import footerComponent from "@/components/footer.vue";
export default {
  components: {
    //navBar,
    footerComponent
  },
  data() {
    return {
      mostrar: true
    };
  },
  methods: {
    mostrarBar() {}
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  //height: 550px !important;
  //overflow-y: scroll !important;
  // overflow-x: hidden;
  font-size: 13px !important;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.layout {
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
</style>
